import React from "react";
import "./Host.css";

const Host = () => {
  return (
    <div className="bg-white py-5">
      <div>
        <div className="container host">
          <div>
            {/* <h1 className="sectionHeader">
            <span className="text-blue " style={{ position: "relative" }}>
              {" "}
              Discover We Share Experience
              <span className="headerPsudo ">
                <img src={headerBg} alt="" />
              </span>
              <span className="headerPsudoText">
                <span className="p">a sustainable life style</span>{" "}
              </span>
            </span>
          </h1> */}
          </div>
          <div className="row ">
            <div className="col-md-12 col-lg-12 py-3">
              <div className="host_content">
                <div className="experience_titile">
                  <h1>
                    <span> Become</span> a host!
                  </h1>
                </div>
                <div className="experience_p">
                  <p className="pb-0 m-0">
                    Anything you own can now earn you income.
                  </p>
                  <p className="pb-0 m-0">
                    Start earning today! We own so much that often don't get
                    used.
                  </p>
                  <p className="blue_text">Let's Share it!</p>
                </div>
                <div>
                  <div className="work">
                    <h3>
                      How it works, <span>Simple!</span>
                    </h3>
                  </div>
                  <div>
                    <div className="img_text pb-1">
                      <h4>Sign up</h4>
                    </div>
                    <div className="img_text">
                      <h4>Describe what you’re sharing</h4>
                    </div>
                    <div className="img_text py-1">
                      <h4>Upload great pictures</h4>
                    </div>
                    <div className="img_text">
                      <h4>Start earning income! </h4>
                    </div>
                    <div className="pt-3">
                      <button className="experience_btn">List an items</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Host;
